import { render, staticRenderFns } from "./CheckOrder.vue?vue&type=template&id=20a554e2&"
import script from "./CheckOrder.vue?vue&type=script&lang=js&"
export * from "./CheckOrder.vue?vue&type=script&lang=js&"
import style0 from "./CheckOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports